export default __webpack_public_path__ + "static/media/editing-control.041956f6.svg";